export const CART_NOT_FOUND_FOR_GIVEN_ID = 'Cart not found for the given id';
export const INVENTORY_NOT_AVAILABLE = 'Requested inventory not available.';
